import React, { useContext, useEffect } from 'react';

import { useTypedParams } from 'react-router-typesafe-routes';
import { ResizableHandler, ScrollableContainer } from '@ergeon/core-components';

import { CustomerContext } from '../../../context-providers/CustomerContext';
import { NoCustomerSelectedEmptyState } from '../../EmptyStates';
import { ROUTES } from '../../../routes';
import { useUnifiedDialog } from '../../../hooks/useUnifiedDialog';
import { CustomerInfo } from '../CustomerInfo';
import { ExecutiveSummary } from '../ExecutiveSummary';
import UnifiedDialog from '../UnifiedDialog';
import { CustomerActivitiesList } from '../Activities';

const CustomerDetails: React.FC = () => {
  const { customerId } = useTypedParams(ROUTES.customer);
  const { customerDetail } = useContext(CustomerContext);
  const { markRead } = useUnifiedDialog();

  // Mark customer as read when viewing
  useEffect(() => {
    if (customerId) {
      markRead(customerId);
    }
  }, [customerId, markRead]);

  if (customerId === undefined) {
    return <NoCustomerSelectedEmptyState />;
  }

  return (
    <ResizableHandler
      defaultAspect="1/1"
      direction="row"
      minFirstSize={30}
      minSecondSize={30}
      storageKey="customer-details-column-width">
      <ResizableHandler.FirstPanel>
        <div className="flex flex-col h-full">
          <UnifiedDialog />
        </div>
      </ResizableHandler.FirstPanel>
      <ResizableHandler.SecondPanel>
        <ScrollableContainer direction="col" gap={4} maskSize={0}>
          <CustomerInfo customerDetail={customerDetail} />
          <CustomerActivitiesList />
          <ExecutiveSummary customerDetail={customerDetail} />
        </ScrollableContainer>
      </ResizableHandler.SecondPanel>
    </ResizableHandler>
  );
};

export default CustomerDetails;
